import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  user: string | null;
  userRole: string | null;
  allowedPages: string[];
}

interface AuthPayload {
  user: {
    displayName?: string;
    role?: string;
    allowedPages?: string[];
  };
}

const user = localStorage.getItem("goalfiAnalysis_user");
const userRole = localStorage.getItem("goalfiAnalysis_user_role");
const allowedPages = JSON.parse(
  localStorage.getItem("goalfy_allowed_Pages") || "[]"
); // Ensure parsing safely

const initialState: AuthState = user
  ? {
      user,
      userRole,
      allowedPages,
    }
  : {
      user: null,
      userRole: null,
      allowedPages: [],
    };

const authDataSlice = createSlice({
  name: "authData",
  initialState,
  reducers: {
    auth(state, action: PayloadAction<AuthPayload>) {
      const { displayName, role, allowedPages } = action.payload.user || {};

      // Store in localStorage
      localStorage.setItem("goalfiAnalysis_user", displayName || "");
      localStorage.setItem("goalfiAnalysis_user_role", role || "");
      localStorage.setItem(
        "goalfy_allowed_Pages",
        JSON.stringify(allowedPages || [])
      );

      // Update state
      state.user = displayName || null;
      state.userRole = role || null;
      state.allowedPages = allowedPages || [];
    },

    logOut(state) {
      // Clear localStorage
      localStorage.removeItem("goalfiAnalysis_user");
      localStorage.removeItem("goalfiAnalysis_user_role");
      localStorage.removeItem("goalfy_allowed_Pages");

      // Reset state
      state.user = null;
      state.userRole = null;
      if (state.allowedPages.length > 0) {
        state.allowedPages = [];
      }
    },
  },
});

export const authDataActions = authDataSlice.actions;
export const logOut = authDataActions.logOut;
export default authDataSlice.reducer;
